import { render, staticRenderFns } from "./IconTrashOutline.vue?vue&type=template&id=86891dee"
import script from "./IconTrashOutline.vue?vue&type=script&lang=js"
export * from "./IconTrashOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports